import React, { useLayoutEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { chartEngine } from '../../../constants/chart-constants';

// TODO: review direct reducer dependency
import * as utils from '../../../reducers/highcharts/highcharts.utils';
import { getPrintDimensions, getViewMultiplier } from '../../../util/cropsUtil';

function getContainerSize({ size, chart }) {
  const { size: sizeId } = size;
  const { manualHeight, sizes } = chart;
  const multiplier = getViewMultiplier(sizeId);
  return getPrintDimensions(sizes[sizeId], manualHeight, multiplier);
}

const InnerChartPrint = ({ sizeOptions, updateHighcharts, chart }) => {
  const containerRef = useRef();
  const chartRef = useRef();
  const cssClass = `render-inner print-wsj`;

  useLayoutEffect(() => {
    function createChart() {
      if (!chartEngine) {
        console.warn('Chart engine is not found');
      } else {
        sizeOptions.el = containerRef.current;

        const [containerWidth, containerHeight] = getContainerSize({ size: sizeOptions, chart });

        containerRef.current.style.height = containerHeight;

        containerRef.current.style.width = containerWidth;

        chartRef.current = chartEngine.render(sizeOptions, true, (highchart) => {
          updateHighcharts(sizeOptions.size, highchart);
          const printSVG = containerRef.current.querySelector('.highcharts-root');

          printSVG.setAttribute('width', containerWidth);
          printSVG.setAttribute('height', containerHeight);
        });
      }
    }

    if (!chartRef.current) {
      createChart();
    }
  });

  return <div className={cssClass} ref={containerRef} />;
};

const mapDispatchToProps = {
  updateHighcharts: utils.updateHighcharts,
};

export default connect(null, mapDispatchToProps)(InnerChartPrint);
